// Forgot-password — reached from the "Forgot password" link on Login. Collects
// an email and asks the backend to (maybe) send a reset link. The backend
// always answers with the same generic message regardless of whether the
// address has an account, so this screen never learns — and never shows —
// whether the email was registered. That's deliberate: it's what keeps the
// endpoint from being usable to enumerate accounts.
import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../../api/auth";
import emtlogo from "../../images/logo.svg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await forgotPassword(email.trim());
      // Always show the same confirmation — see the note above.
      setSent(true);
    } catch (err) {
      setError(
        err.response?.data?.error || "Something went wrong. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-bg-wrap">
      <video
        className="login-bg-video"
        src="/videos/login-bg.mp4"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      />
      <div className="login-bg-overlay" aria-hidden="true" />
      <div className="container">
        <div className="login-page">
          <div className="item">
            <div className="signin-wrap">
              <div className="signin-form">
                <div className="elogo elogo-inside">
                  <img src={emtlogo} alt="Logo" />
                </div>

                {sent ? (
                  <>
                    <div className="title">
                      <h3>Check your email</h3>
                      <p>
                        If an account exists for <strong>{email.trim()}</strong>,
                        we've sent a link to reset your password. It expires in
                        1 hour.
                      </p>
                    </div>
                    <p className="siup-txt">
                      <Link to="/login">Back to sign in</Link>
                    </p>
                  </>
                ) : (
                  <>
                    <div className="title">
                      <h3>Forgot password?</h3>
                      <p>
                        Enter the email on your account and we'll send you a
                        link to reset your password.
                      </p>
                    </div>
                    <div className="login-form">
                      <form onSubmit={handleSubmit} className="loginwrap">
                        <div className="form-item">
                          <label>Email Address</label>
                          <input
                            name="email"
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>

                        {error && (
                          <p
                            style={{
                              color: "#e7000b",
                              font: "400 12px/1.5 inherit",
                              margin: "6px 0 0",
                            }}
                          >
                            {error}
                          </p>
                        )}

                        <div className="form-action">
                          <button
                            type="submit"
                            className="btn-orange"
                            disabled={submitting}
                          >
                            {submitting ? "Sending…" : "Send reset link"}
                          </button>
                        </div>

                        <p className="siup-txt">
                          <Link to="/login">Back to sign in</Link>
                        </p>
                      </form>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
